import { TagColor as Color } from '@factorialco/deprecated-design-system'

import type QuestionGroup from 'modules/reviews/store/models/QuestionGroup'

export const getType = (questionGroup: QuestionGroup) => {
  const StateColor = {
    draft: Color.champagne,
    answered: Color.malibu,
    closed: Color.grey,
    active: Color.lime,
  }
  if (questionGroup.isDraft) return StateColor.draft

  if (questionGroup.isAnswered) return StateColor.answered

  if (questionGroup.isClosed) return StateColor.closed

  return StateColor.active
}
